module.exports = __webpack_public_path__ + "static/media/food-logo.e7fccba7.png";